import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import { Footer } from "./Footer";
import { HeroAlt } from "./HeroAlt";
import Navigation from "./Navigation";

export const PricesPage = () => {
  return (
    <div>
      <header>
        <Navigation />
        <HeroAlt
          title="Prices"
          pageDescription="Here you will be able to outline a list of your services with some price examples to entice potential customers into using your services."
        />
      </header>
      <main className="prices-page">
        <Container>
          <Row>
            <Col data-aos="fade-in">
              <h2>Price List</h2>
              <div className="underline"></div>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam sit
                amet purus augue. Ut sagittis fermentum neque, eu imperdiet mi
                pellentesque quis.
              </p>
              <Table striped bordered>
                <thead>
                  <tr>
                    <th>Item</th>
                    <th>Price</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Item One Name</td>
                    <td>£5.00</td>
                  </tr>
                  <tr>
                    <td>Item Two Name</td>
                    <td>£10.00</td>
                  </tr>
                  <tr>
                    <td>Item Three Name</td>
                    <td>£15.00</td>
                  </tr>
                  <tr>
                    <td>Item Four Name</td>
                    <td>£20.00</td>
                  </tr>
                  <tr>
                    <td>Item Five Name</td>
                    <td>£25.00</td>
                  </tr>
                  <tr>
                    <td>Item Six Name</td>
                    <td>£30.00</td>
                  </tr>
                  <tr>
                    <td>Item Seven Name</td>
                    <td>£35.00</td>
                  </tr>
                  <tr>
                    <td>Item Eight Name</td>
                    <td>£40.00</td>
                  </tr>
                  <tr>
                    <td>Item Nine Name</td>
                    <td>£45.00</td>
                  </tr>
                  <tr>
                    <td>Item Ten Name</td>
                    <td>£50.00</td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>
        </Container>
      </main>
      <footer>
        <Footer />
      </footer>
    </div>
  );
};
